export enum RoleEnum {
  ADMINISTRATOR = 'ADMINISTRATOR',
  RESPONSIBLE = 'RESPONSIBLE',
  READER = 'READER',
  SYSADMIN = 'SYSADMIN',
  MANAGER = 'MANAGER',
}
